import { motion } from "framer-motion";

export default function Manifesto() {
  return (
    <section
      id="manifeste"
      data-testid="manifesto-section"
      className="section relative bg-bone overflow-hidden"
    >
      <div className="container-max">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-3">
            <p className="overline">— Manifeste</p>
            <p className="mt-6 font-display text-3xl text-ink/70 italic leading-snug">
              "La rénovation n'est pas une réparation, c'est une révélation."
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-9"
          >
            <h2 className="font-display font-light text-4xl md:text-6xl leading-[1.05] tracking-tight">
              Nous habitons les murs anciens pour leur faire dire des choses neuves.
              <span className="text-ink/40"> Architecture, lumière, matière, silence —</span>
              <span className="italic text-terracotta"> tout participe du soin.</span>
            </h2>

            <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-12 text-ink/80">
              <div>
                <p className="font-display text-5xl text-terracotta">01</p>
                <h3 className="mt-3 font-display text-2xl">Étudier</h3>
                <p className="mt-2 leading-relaxed">Visite technique, relevé, étude des contraintes haussmanniennes ou contemporaines. Nous comprenons avant de proposer.</p>
              </div>
              <div>
                <p className="font-display text-5xl text-terracotta">02</p>
                <h3 className="mt-3 font-display text-2xl">Composer</h3>
                <p className="mt-2 leading-relaxed">Plans, axonométries, planches matières, échantillons posés sur place. Un avant-projet validé dans le réel.</p>
              </div>
              <div>
                <p className="font-display text-5xl text-terracotta">03</p>
                <h3 className="mt-3 font-display text-2xl">Livrer</h3>
                <p className="mt-2 leading-relaxed">Chantier orchestré par un chef de projet unique. Réception en présence de l'architecte, suivi parfait achèvement.</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
